export enum EmailStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export enum ReviewStatus {
  PENDING_ANSWER = 'PENDING_ANSWER',
  RESPONDED = 'RESPONDED',
  REJECTED = 'REJECTED',
  REJECTED_WAITING_FOR_RESPOND = 'REJECTED_WAITING_FOR_RESPOND',
  APPROVED = 'APPROVED'
}

export enum EmailType {
  CONFERENCIA_CAIXA = 'CONFERENCIA_CAIXA',
  COMPROVANTE_DEPOSITOS = 'COMPROVANTE_DEPOSITOS',
  LANCAMENTO_DEPOSITOS = 'LANCAMENTO_DEPOSITOS'
}

export const EMAIL_TYPE_LABELS: Record<string, string> = {
  [EmailType.CONFERENCIA_CAIXA]: "Conferência de Caixa",
  [EmailType.COMPROVANTE_DEPOSITOS]: "Comprovante de Nsu",
  [EmailType.LANCAMENTO_DEPOSITOS]: "Lançamento de Nsu",
}

export const getEmailTypeLabel = (type: string): string => {
  return EMAIL_TYPE_LABELS[type] ?? type
}

export enum ItemType {
  DIVERGENCE = 'DIVERGENCE',
  NSU = 'NSU'
}

const statusVariantMap: Record<string, "default" | "destructive" | "secondary"> = {
  [ReviewStatus.APPROVED]: "default",
  [ReviewStatus.RESPONDED]: "default",
  [ReviewStatus.REJECTED]: "destructive",
  [ReviewStatus.REJECTED_WAITING_FOR_RESPOND]: "destructive",
  [ReviewStatus.PENDING_ANSWER]: "secondary",
}

export const getStatusVariant = (status: string): "default" | "destructive" | "secondary" => {
  return statusVariantMap[status] ?? "secondary"
}

const statusLabelMap: Record<string, string> = {
  [ReviewStatus.APPROVED]: "Aprovado",
  [ReviewStatus.RESPONDED]: "Respondido",
  [ReviewStatus.REJECTED]: "Reprovado",
  [ReviewStatus.REJECTED_WAITING_FOR_RESPOND]: "Aguardando Nova Resposta",
  [ReviewStatus.PENDING_ANSWER]: "Aguardando Resposta",
}

export const getStatusLabel = (status: string): string => {
  return statusLabelMap[status] ?? "Aguardando Resposta"
}

const emailStatusLabelMap: Record<string, string> = {
  [EmailStatus.APPROVED]: "Aprovado",
  [EmailStatus.REJECTED]: "Reprovado",
  [EmailStatus.PENDING]: "Pendente",
}

export const getEmailStatusLabel = (status: string): string => {
  return emailStatusLabelMap[status] ?? "Pendente"
}

const emailStatusVariantMap: Record<string, "default" | "destructive" | "secondary"> = {
  [EmailStatus.APPROVED]: "default",
  [EmailStatus.REJECTED]: "destructive",
  [EmailStatus.PENDING]: "secondary",
}

export const getEmailStatusVariant = (status: string): "default" | "destructive" | "secondary" => {
  return emailStatusVariantMap[status] ?? "secondary"
}
